export default __webpack_public_path__ + "static/media/analytics-icon.8322b76f.svg";